import { ReactComponent as IconProfile } from 'assets/icons/IconProfile.svg';
import { IconAccessLog, IconDiary, IconLicense, IconLiveCaptions, IconManagerSIP, 
    IconManagerSystem, IconMeetingSchedule, IconMonitor, IconOrganization, IconPhonebook, IconRecording, IconRole, IconUser, IconWB } from 'assets/sidebar';
import IconManageVersion from 'assets/sidebar/IconManageVersion';
import IconMCUControl from 'assets/sidebar/iconMCUControl';
import IconMCUSettings from 'assets/sidebar/iconMCUSettings';
import IconMCUStatus from 'assets/sidebar/iconMCUStatus';

import IconMemberManagemet from 'assets/sidebar/IconMemberManagemet';
import IconPackageManagement from 'assets/sidebar/IconPackageManagement';
import IconStorage from 'assets/sidebar/IconStorage';
import { IconHistoryPage, IconLangdingPage } from 'components/common/IconCommon';

const IconBreadcrumb = ({ crumb = "" }) => {
    switch (crumb) {
        case "manager-meeting":
            return <IconMeetingSchedule />
        case "manager-users":
        case "create-user":
        case "update-user":
            return <IconUser />
        case "manager-whiteboard":
            return <IconWB />
        case "manager-recordings":
            return <IconRecording />
        case "access-log":
            return <IconAccessLog />
        case "profile":
            return <IconProfile />
        case "profile-user":
            return <IconProfile />
        case "contacts":
            return <IconPhonebook />
        case "organization":
            return <IconOrganization />
        case "manager-diary":
            return <IconDiary />
        case "manager-sip":
            return <IconManagerSIP />
        case "license":
            return <IconLicense />
        case "manager-roles":
        case "manager-function":
            return <IconRole />
        case "manager-systems":
            return <IconManagerSystem />
        case "manager-user-sip":
        case "create-user-sip":
        case "edit-user-sip":
            return <IconManagerSIP />
        case "manager-historys":
            return <IconDiary />
        case "manager-backup":
            return <IconDiary />
        case "manager-monitor":
            return <IconMonitor />
        case "meeting-monitor":
            return <IconMonitor />
        case "live-captions":
            return <IconLiveCaptions />
        case "history":
            return <IconHistoryPage />
        case "service-package-management":
            return <IconPackageManagement />
        case "member-management":
            return <IconMemberManagemet />
        case "content-landingpage":
            return <IconLangdingPage />
        case "manager-storage": 
            return <IconStorage />
        case "manager-version":
            return <IconManageVersion />
        case "mcu-control":
            return <IconMCUControl/>
        case "mcu-status":
            return <IconMCUStatus/>
        case "mcu-settings":
            return <IconMCUSettings/>
        default:
            return <></>
    }
}

export default IconBreadcrumb